import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

import Button from "material-ui/Button";
import Typography from "material-ui/Typography";

import Wrapper from "../../../common/Wrapper";
import Header from "../../../common/Header";
import ContactInfoInner from "../../../SendLetter/dialogs/ContactInfoInner";

import Loader from "../../../Parts/Loader";
import NotificationBar from "../../../Parts/NotificationBar.jsx";

import ProgressBar from "../common/ProgressBar";
import SalesforceMapping from "./SalesforceMapping";
import SalesforceSettingComplete from "../common/SalesforceSettingComplete";
import SalesforceSelectObject from "./SalesforceSelectObject";
import SalesforceSelectListview from "./SalesforceSelectListview";

import {
  SalesforceImportStep,
  salesforceImportMappingFormProps,
  DialogType,
  salesforceAddressSettingSteps,
  SalesforceSettingDirectory,
  SalesforceObjectType,
} from "../../../../constants/ComponentTypes";
import { defaultSalesforceMapping } from "../../../../constants/SalesforceMapping.js";
import { makeSalesforceMap } from "../../../../utils/utils";

const { Set, Map } = require("immutable");

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
  },

  content: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "scroll",
  },

  overview: {
    background: "#F4F6F9",
    flex: 1,
    width: "80%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    maxWidth: "1200px",
    margin: "auto",
    padding: "20px",
    boxSizing: "border-box",
  },

  progressbar: {
    marginTop: "22px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  cancelBtn: {
    position: "absolute",
    top: 0,
    right: 0,
    margin: "15px 23px 0px 0px",
    padding: "8px 15px",
    fontSize: "13px",
    minWidth: "unset",
    minHeight: "unset",
  },

  box: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  sectionTitle: {
    fontWeight: "bold",
    marginBottom: "36px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },
});

class SalesforceAddressSetup extends React.Component {
  state = {
    step: SalesforceImportStep.SELECT_OBJECT,
    showNotification: false,
    message: "",
    messageType: "success",
    mapping: Map(),
    sobject_name: 0,
    listview_id: null,
    enableExport: false,
  };

  componentWillMount() {
    this.props.getUserInfo();
    this.props.getSalesforceConfig();

    let mapping = this.state.mapping;
    salesforceImportMappingFormProps.forEach((prop) => {
      mapping = mapping.set(prop.key, Set());
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.successMessage && nextProps.successMessage !== "") {
      this.displayNotification(nextProps.successMessage, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== "") {
      this.displayNotification(nextProps.errorMessage, "error");
    } else if (nextProps.shortMessage && nextProps.shortMessage !== "") {
      this.displayNotification(nextProps.shortMessage, "green");
    }

    // 設定済みの場合、設定画面にリダイレクト
    if (this.props.isLoadingConfig && !nextProps.isLoadingConfig) {
      if (nextProps.address_import_mappings_flag) {
        nextProps.replace(SalesforceSettingDirectory.ADDRESS_BOOK.setting_path);
      }
    }
  }

  componentDidUpdate(prevProps) {
    // ジョブ実行後でリロードされた場合を考慮し、ユーザー情報が取得でき次第、接続・再接続する
    if (this.props.user && !prevProps.user) {
      this.props.jobCompleted(this.props.user.id);
    }
  }

  /*** toggle funcions ***/
  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  /*** handlers ***/
  goToStep = (step) => {
    this.setState({ step: step });
  };

  handleSelectSobject = (e) => {
    this.setState({
      sobject_name: e.target.value,
      mapping: makeSalesforceMap(defaultSalesforceMapping[e.target.value]),
    });

    this.props.getSalesforceDescribe(e.target.value);
    this.props.getSalesforceListviews(e.target.value);
  };

  handleSelectListview = (importFromListview, listview_id) => {
    if (importFromListview) {
      this.setState({
        listview_id: listview_id,
      });
    } else {
      this.setState({
        listview_id: null,
      });
    }
  };

  handleUpdateMapping = (mapping) => {
    this.setState({
      mapping: mapping,
    });
  };

  /*** render functions ***/
  renderNotification = () => {
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          top: 10,
          width: "98%",
          left: "1%",
        }}
      >
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false });
          }}
          autoClose={false}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : "100%",
          }}
        ></NotificationBar>
      </div>
    );
  };

  renderLoading = () => (
    <div className={this.props.classes.overview}>
      <div className={this.props.classes.box}>
        <Loader type="color" />
      </div>
    </div>
  );

  renderContactBox = () => (
    <div className={this.props.classes.overview}>
      <div className={this.props.classes.box}>
        <Typography variant="title" className={this.props.classes.sectionTitle}>
          現在ご利用のプランでは、Salesforce連携機能がサポートされていません
        </Typography>

        <ContactInfoInner />
      </div>
    </div>
  );

  renderAuthorizeBox = () => {
    const { classes } = this.props;

    return (
      <div className={classes.overview}>
        <div className={classes.box} style={{ minHeight: "unset" }}>
          <Typography variant="subheading">
            認証情報が見つかりません。
            <a
              href={
                process.env.REACT_APP_API_BASE_URL +
                "/oauth2/salesforce?redirect_url=" +
                process.env.REACT_APP_FRONTEND_URL +
                "/setting/integrations/salesforce"
              }
              target="_self"
              className={classes.link}
            >
              こちら
            </a>
            より設定してください。
          </Typography>
        </div>
      </div>
    );
  };

  renderSelectObject = () => (
    <SalesforceSelectObject
      sobject={this.state.sobject_name}
      next={() => this.goToStep(SalesforceImportStep.SELECT_LISTVIEW)}
      handleSelectSobject={this.handleSelectSobject}
      isLoading={this.props.isLoadingListviews}
      menu={Object.values(SalesforceObjectType)}
    />
  );

  renderSelectListview = () => (
    <SalesforceSelectListview
      sobject={this.state.sobject_name}
      listviews={this.props.listviews}
      listview_id={this.state.listview_id}
      prev={() => {
        this.goToStep(SalesforceImportStep.SELECT_OBJECT);
        this.setState({
          listview_id: null,
        });
      }}
      next={() => this.goToStep(SalesforceImportStep.MAPPING)}
      handleSelectListview={this.handleSelectListview}
      isLoadingFields={this.props.isLoadingFields}
    />
  );

  renderMapping = () => (
    <SalesforceMapping
      sobject={this.state.sobject_name}
      listview_id={this.state.listview_id}
      listviews={this.props.listviews}
      enableExport={true}
      user={this.props.user}
      type={DialogType.CREATE}
      step={this.state.step}
      mapping={this.state.mapping}
      fields={this.props.fields}
      preview={this.props.preview}
      isLoadingPreview={this.props.isLoadingPreview}
      isJobCompletedLoading={this.props.isJobCompletedLoading}
      isConfiguring={this.props.isConfiguring}
      goBack={this.props.goBack}
      goToStep={this.goToStep}
      updateMapping={this.handleUpdateMapping}
      loadingPreviewFailed={this.props.loadingPreviewFailed}
      postSalesforceConfig={(data) =>
        this.props.postSalesforceConfig({
          ...data,
          sobject_name: this.state.sobject_name,
        })
      }
      getSalesforcePreview={(data) =>
        this.props.getSalesforcePreview(this.state.sobject_name, data)
      }
    />
  );

  render() {
    const { classes } = this.props;

    let notification;
    if (this.state.showNotification) {
      notification = this.renderNotification();
    }

    return (
      <Wrapper className={classes.root}>
        <Header
          title="Salesforce連携設定"
          secondaryTitle="自社リスト連携設定"
          type="dark"
          hasBackBtn={false}
          onTitleClicked={() =>
            this.props.goTo("/setting/integrations/salesforce")
          }
        />
        <div className={classes.content}>
          {(() => {
            if (this.props.user) {
              if (!this.props.user.salesforce_integration_flag) {
                return this.renderContactBox();
              } else if (!this.props.user.integrations.salesforce) {
                return this.renderAuthorizeBox();
              } else if (this.props.isLoadingConfig) {
                return this.renderLoading();
              } else {
                if (this.state.step === SalesforceImportStep.SETTING_COMPLETE) {
                  return (
                    <SalesforceSettingComplete
                      goTo={this.props.goTo}
                      type={SalesforceSettingDirectory.ADDRESS_BOOK.value}
                      dialogType={DialogType.CREATE}
                      postSalesforceSync={() => {
                        this.props.initializeMessage();
                        this.props.postSalesforceSync();
                      }}
                      isJobCompletedLoading={this.props.isJobCompletedLoading}
                    />
                  );
                } else {
                  return (
                    <div>
                      <div className={classes.progressbar}>
                        <ProgressBar
                          step={this.state.step}
                          steps={salesforceAddressSettingSteps}
                        />
                        <Button
                          className={classes.cancelBtn}
                          onClick={() => {
                            if (
                              window.confirm(
                                "設定をキャンセルします。よろしいですか？"
                              )
                            ) {
                              this.props.goTo(
                                "/setting/integrations/salesforce"
                              );
                            }
                          }}
                        >
                          キャンセル
                        </Button>
                      </div>

                      {(() => {
                        if (
                          this.state.step === SalesforceImportStep.SELECT_OBJECT
                        ) {
                          return this.renderSelectObject();
                        } else if (
                          this.state.step ===
                          SalesforceImportStep.SELECT_LISTVIEW
                        ) {
                          return this.renderSelectListview();
                        } else if (
                          this.state.step === SalesforceImportStep.MAPPING ||
                          this.state.step === SalesforceImportStep.PREVIEW
                        ) {
                          return this.renderMapping();
                        }
                      })()}
                    </div>
                  );
                }
              }
            }
          })()}
        </div>
        {notification}
      </Wrapper>
    );
  }
}

SalesforceAddressSetup.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  message: PropTypes.string,
  isSaving: PropTypes.bool,
  error: PropTypes.object,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  isLoadingConfig: PropTypes.bool,
  isLoadingListviews: PropTypes.bool,
  isLoadingFields: PropTypes.bool,
  isLoadingPreview: PropTypes.bool,
  isJobCompletedLoading: PropTypes.bool,
  isConfiguring: PropTypes.bool,
  loadingPreviewFailed: PropTypes.bool,
  preview: PropTypes.array,
  listviews: PropTypes.array,
  fields: PropTypes.object,
  goBack: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  getSalesforceConfig: PropTypes.func.isRequired,
  getSalesforceDescribe: PropTypes.func.isRequired,
  getSalesforceListviews: PropTypes.func.isRequired,
  getSalesforcePreview: PropTypes.func.isRequired,
  postSalesforceConfig: PropTypes.func.isRequired,
  postSalesforceSync: PropTypes.func.isRequired,
  replace: PropTypes.func.isRequired,
  address_import_mappings_flag: PropTypes.bool,
  initializeMessage: PropTypes.func.isRequired,
  jobCompleted: PropTypes.func.isRequired,
};

export default withStyles(styles)(SalesforceAddressSetup);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceAddressSetting/SalesforceAddressSetup.jsx